var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass:
        "card ob1-push bg-dark ob1-push-zigzag ob1-push-zigzag-odd p-0",
    },
    [
      _c(
        "div",
        {
          staticClass:
            "card-item px-0 d-flex justify-content-center align-items-center h-100 pt-2 pt-md-0",
        },
        [
          _c("img", {
            staticClass: "img-fluid image",
            attrs: { loading: "lazy", alt: _vm.dto.alt, src: _vm.dto.picture },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "card-item h-100 p-2 bg-dark text-white" }, [
        _c(
          "div",
          { staticClass: "px-md-1 px-xl-5 align-self-center text-center" },
          [
            _c(
              "strong",
              {
                staticClass:
                  "ob1-tag ob1-tag-inverse ob1-tag-primary mx-auto mb-1",
              },
              [
                _vm._v(
                  "\n                " + _vm._s(_vm.dto.tag) + "\n            "
                ),
              ]
            ),
            _vm._v(" "),
            _c("h3", {
              staticClass: "h4 mb-1 mx-auto",
              domProps: { innerHTML: _vm._s(_vm.dto.title) },
            }),
            _vm._v(" "),
            _c("p", {
              staticClass: "card-text text-white col-8 col-md-12 mx-auto",
              domProps: { innerHTML: _vm._s(_vm.dto.description) },
            }),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn btn-secondary btn-inverse",
                attrs: {
                  target: "_blank",
                  href: _vm.dto.linkUrl,
                  "data-oevent-category": _vm.dto.linkTms.category,
                  "data-oevent-label": _vm.dto.linkTms.label,
                  "data-oevent-action": _vm.dto.linkTms.action,
                },
              },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.dto.linkLabel) +
                    "\n            "
                ),
              ]
            ),
          ]
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }